import { memo } from "react";

import styles from "./NarmiDashboardTile.module.scss";

import { NarmiTile } from ".";

type Props = {
  tile: API.NarmiTile;
};

const NarmiDashboardTile = ({ tile }: Props) => {
  return (
    <div className={styles["dashboard-tile-container"]}>
      <NarmiTile tile={tile} fixedHeight="100%" />
    </div>
  );
};

export default memo(NarmiDashboardTile);
